/*
 * @Author: your name
 * @Date: 2020-10-09 10:53:20
 * @LastEditTime: 2021-02-25 10:05:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isLoading: false,//loading全局开关
    roleType: '',
    userId: '',
    memberInfo: {},
    // yearData: [],
    toToData: {
      userMemberNumber: '',  //会员未认证
      paymentNumber: '',  // 缴纳会费
      questionNumber: '', // 调查表数量
      productNumber: '', // 发布产品数量
      companyNumber: '', //公司未完善
    },
    memberToDo: [],
    outData: []
  },
  mutations: {
    saveRoleType(state, roleType) {
      state.roleType = roleType
      window.sessionStorage.setItem('roleType', state.roleType)
    },
    saveUserId(state, userId) {
      state.userId = userId
      window.sessionStorage.setItem('userId', state.userId)
    },
    saveMemberInfo(state, memberInfo) {
      state.memberInfo = memberInfo
      window.sessionStorage.setItem('memberInfo', JSON.stringify(state.memberInfo))
    },
    // saveYearData(state, yearData) {
    //   state.yearData = yearData
    //   window.sessionStorage.setItem('yearData', JSON.stringify(state.yearData))
    // },
    saveToDo(state, toToData) {
      state.toToData = toToData
      window.sessionStorage.setItem('toToData', JSON.stringify(state.toToData))

    },
    saveMemberToDo(state, memberToDo) {
      state.memberToDo = memberToDo
      window.sessionStorage.setItem('memberToDo', JSON.stringify(state.memberToDo))
    },
    // 外部接口爬过来的数据
    saveOutData(state, outData) {
      state.outData = outData
      window.sessionStorage.setItem('outData', JSON.stringify(outData))
    },
  },
})
export default store